import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import SEOHead from "@/components/feature/SEOHead";
import ComicCard from "@/components/base/ComicCard";
import { comics } from "@/mocks/comics";
import { categories } from "@/mocks/categories";

const hotComics = comics.sort((a, b) => b.views - a.views).slice(0, 6);
const latestComics = [...comics].sort(
  (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
).slice(0, 8);
const topRated = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 6);
const featuredComics = comics.slice(0, 4);

export default function Home() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "韩漫漫画网 - 韩漫画免费网站_漫画大全_韩漫完整在线观看",
    description:
      "韩漫漫画网作为韩漫画免费网站，提供漫画大全和韩漫完整在线观看，内容覆盖广更新快，是您探索韩漫世界的入口。",
    url: "https://www.hanmancomic.com/",
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "韩漫漫画网是免费的吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "是的，韩漫漫画网是一个完全免费的韩漫在线阅读网站，所有漫画资源均可免费观看，无需付费或订阅。",
        },
      },
      {
        "@type": "Question",
        name: "韩漫漫画网的更新频率如何？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫漫画网每日更新，与韩国漫画同步，确保读者能够第一时间看到最新的韩漫内容。热门作品通常每周更新1-2话。",
        },
      },
      {
        "@type": "Question",
        name: "韩漫漫画网支持哪些设备阅读？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫漫画网支持电脑、平板和手机等多种设备在线阅读，自适应屏幕尺寸，提供流畅的阅读体验。",
        },
      },
      {
        "@type": "Question",
        name: "韩漫漫画网有哪些类型的漫画？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫漫画网涵盖恋爱、奇幻、动作、悬疑、搞笑、耽美、剧情等多种类型，满足不同读者的喜好和需求。",
        },
      },
    ],
  };

  return (
    <Layout>
      <SEOHead
        title="韩漫漫画网 - 韩漫画免费网站_漫画大全_韩漫完整在线观看"
        description="韩漫漫画网作为韩漫画免费网站，提供漫画大全和韩漫完整在线观看，内容覆盖广更新快，是您探索韩漫世界的入口。收录热门韩漫、最新韩漫、完结韩漫，支持手机和电脑在线阅读。"
        keywords="韩漫漫画网,韩漫画免费网站,漫画大全,韩漫完整在线观看,韩漫在线看,韩国漫画,免费漫画"
        canonicalUrl="https://www.hanmancomic.com/"
        schemaJson={[homeSchema, faqSchema]}
      />

      <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20stylized%20illustration%20of%20a%20dreamy%20comic%20world%20with%20floating%20comic%20panels%20and%20characters%20in%20soft%20watercolor%20style%2C%20Korean%20manhwa%20aesthetic%2C%20warm%20coral%20pink%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20featuring%20swirling%20ink%20and%20brush%20strokes%2C%20ethereal%20and%20captivating%20atmosphere%2C%20digital%20painting%20with%20traditional%20ink%20wash%20texture%2C%20romantic%20and%20fantasy%20vibe%2C%20clean%20artistic%20composition&width=1800&height=800&seq=hanman-hero-bg&orientation=landscape"
          alt="韩漫漫画网 - 韩漫完整在线观看"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            探索韩漫的无限世界
          </h2>
          <p className="text-sm md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
            韩漫漫画网为您提供漫画大全和韩漫完整在线观看，内容覆盖广更新快，是您探索韩漫世界的入口
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-white/30 transition-colors cursor-pointer border border-white/30"
            >
              热门恋爱
            </Link>
          </div>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </section>

      <section className="bg-background-100/70 py-10 md:py-14">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <Link
              to="/category/all"
              className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              更多 <i className="ri-arrow-right-s-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {latestComics.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              高分排行
            </h2>
            <div className="space-y-3">
              {topRated.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/article/${comic.id}`}
                  className="flex items-center gap-4 p-3 rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <span
                    className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-background-50 whitespace-nowrap ${
                      index < 3 ? "bg-accent-500" : "bg-foreground-400"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0 bg-background-100">
                    <img
                      src={comic.cover}
                      alt={`${comic.title} - 韩漫漫画网`}
                      className="w-full h-full object-cover"
                      width="48"
                      height="64"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-900 truncate">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-0.5 truncate">
                      {comic.author}
                    </p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <span className="text-sm font-bold text-accent-500">{comic.rating}</span>
                    <p className="text-xs text-foreground-400 mt-0.5 whitespace-nowrap">
                      {(comic.views / 10000).toFixed(0)}万阅读
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-[320px] flex-shrink-0">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              分类浏览
            </h2>
            <div className="grid grid-cols-2 gap-2">
              {categories
                .filter((c) => c.slug !== "all")
                .map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="flex items-center justify-between p-3 rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-300 hover:bg-background-100/70 transition-all duration-300 cursor-pointer"
                  >
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                      {cat.name}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {cat.count}部
                    </span>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100/70 py-10 md:py-14">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
            精选推荐
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {featuredComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="group relative rounded-lg overflow-hidden aspect-[16/9] bg-background-200 cursor-pointer"
              >
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩漫完整在线观看`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  width="600"
                  height="338"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-base font-semibold text-white truncate">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-white/70 mt-1 line-clamp-2">
                    {comic.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <article>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
            关于韩漫漫画网
          </h2>
          <div className="prose max-w-none">
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              <strong>韩漫漫画网</strong>是领先的<strong>韩漫画免费网站</strong>，致力于为广大漫画爱好者提供最全面的<strong>漫画大全</strong>和<strong>韩漫完整在线观看</strong>服务。
              作为专业的韩漫平台，我们收录了上千部高质量韩国漫画，涵盖恋爱、奇幻、动作、悬疑、搞笑、耽美等多种类型，满足不同读者的阅读需求。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              韩漫漫画网坚持每日更新，第一时间同步韩国最新连载，让读者不错过任何精彩内容。无论是热门连载还是经典完结作品，
              都能在这里找到完整的阅读体验。我们的网站支持手机和电脑等多种设备，随时随地畅享韩漫阅读的乐趣。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩漫漫画网始终以用户体验为核心，界面简洁清晰，阅读流畅便捷。加入韩漫漫画网，开启您的韩漫探索之旅，发现更多精彩漫画世界。
            </p>
          </div>
        </article>
      </section>

      <section className="bg-background-100/70 py-10 md:py-14">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
            常见问题
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {faqSchema.mainEntity.map((faq, i) => (
              <div
                key={i}
                className="p-4 rounded-lg border border-background-200/70 bg-background-50"
              >
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  {faq.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.acceptedAnswer.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}